import React, { Component } from "react";
import "./styles.css";
import Icon from "../../prefabs/icon/view";




class BirthdayExtra extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onButtonClick = this.onButtonClick.bind(this);
  }



  // ===============================================================================================
  onButtonClick() {
    this.props.handleClick({
      id:   this.props.id,
      name: this.props.name,
      age:  this.props.age,
    });
  }



  // ===============================================================================================
  getSuffixedAge() {
    let num = (this.props.age) ? parseInt(this.props.age, 10) : 0;  // Base 10 radix
    return (typeof num === "number") ? this.props.age + this.getOrdinalSuffix(num) : "";
  }



  // ===============================================================================================
  getOrdinalSuffix(num) {
    // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) { return "st"; }
    if (j === 2 && k !== 12) { return "nd"; }
    if (j === 3 && k !== 13) { return "rd"; }
    return "th";
  }



  // ===============================================================================================
  getSuffixedName() {
    let str = (this.props.name) ? this.props.name : "";
    if (str.endsWith('s') || str.endsWith('S')) {
        return str + "’";
    }
    return str + "’s";
  }



  // ===============================================================================================
  render() {
    return (
      <div className={"birthdays__starlist__item" +
        ((this.props.hidden) ? " birthdays__starlist__item--hidden" : "")}>

        <button className="item-contents" onClick={this.onButtonClick}>
          {this.getSuffixedName()}
          &nbsp;
          {this.props.eventType === 'hosted' && this.getSuffixedAge()}
          <Icon type="close"/>
        </button>

      </div>
    );
  }

}



export default BirthdayExtra
